/** FE Templates UI ids ↔ backend EVCAgentType / EVCAgentSubType (ATT-28 F4). */

export type AgentTemplateUiId =
  | 'bom'
  | 'supplier-investigation'
  | 'reputation-monitoring'
  | 'regulation-monitoring'
  | 'finance-monitoring'
  | 'climate-monitoring'
  | 'ownership-monitoring';

export type AgentTemplateTypeSubType = {
  type: string,
  subType: string,
};

export const AGENT_TEMPLATE_UI_MAP: Record<AgentTemplateUiId, AgentTemplateTypeSubType> = {
  bom: { type: 'n-tier-discovery', subType: 'bill-of-materials' },
  'supplier-investigation': { type: 'n-tier-discovery', subType: 'supplier-discovery' },
  'reputation-monitoring': { type: 'reputation-monitoring', subType: 'media-sentiment' },
  'regulation-monitoring': { type: 'regulation-monitoring', subType: 'regulation-tracking' },
  'finance-monitoring': { type: 'finance-monitoring', subType: 'financial-risk' },
  'climate-monitoring': { type: 'climate-monitoring', subType: 'climate-risk' },
  'ownership-monitoring': { type: 'ownership-monitoring', subType: 'ownership-monitoring' },
};

export const AGENT_TEMPLATE_UI_IDS = Object.keys(AGENT_TEMPLATE_UI_MAP) as AgentTemplateUiId[];

export function isAgentTemplateUiId(value: string): value is AgentTemplateUiId {
  return value in AGENT_TEMPLATE_UI_MAP;
}

export function uiIdToTypeSubType(uiId: string): AgentTemplateTypeSubType {
  if (!isAgentTemplateUiId(uiId)) {
    throw new Error(`Unknown agent template UI id: ${uiId}`);
  }
  return AGENT_TEMPLATE_UI_MAP[uiId];
}

export function typeSubTypeToUiId(type: string, subType: string): AgentTemplateUiId {
  const entry = (Object.entries(AGENT_TEMPLATE_UI_MAP) as [AgentTemplateUiId, AgentTemplateTypeSubType][])
    .find(([, pair]) => pair.type === type && pair.subType === subType);
  if (!entry) {
    throw new Error(`No UI id for type=${type} subType=${subType}`);
  }
  return entry[0];
}
